import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../config";

interface StaticRowProps {
  label: string;
  value: string;
}

export default function StaticRow({ label, value }: StaticRowProps) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ 
        py: 0.375,
        minHeight: "26px",
        pr: "20px",
      }}
    >
      <Typography fontSize="12px" fontWeight={500} color={colors.text.primary} lineHeight="20px">
        {label}
      </Typography>
      <Typography fontSize="12px" fontWeight={500} color={colors.text.primary} lineHeight="20px">
        {value}
      </Typography>
    </Box>
  );
}

